export const HEADERS_TABLE_LIST = [
    { title: "Nombre del espacio" },
    { title: "Deportes disponibles" },
    { title: "Aforo mínimo" },
    { title: "Aforo máximo" },
    { title: "Dirección" },
    { title: "Ubicación / Referencia" },
    { title: "Detalles" },
    { title: "Fecha" }
];